/**
 * Use Task Template API
 * Feature: Generic Configurable Task System
 * Branch: 022-i-like-all
 */

import axiosInstance from '@/api/axiosInstance';
import { UseTaskTemplateRequest, TaskInstanceResponse } from './types';

export async function useTaskTemplate(
  templateId: string,
  data: UseTaskTemplateRequest
): Promise<{ data: TaskInstanceResponse }> {
  const response = await axiosInstance.post<TaskInstanceResponse>(
    `/api/task-templates/${templateId}/use`,
    data
  );

  return { data: response.data };
}